<template>
    <div class='aTop'>
      <div class='edge'>
        <div class='edgeItem' v-for="item in leftData">
          <div class='keyEmptyView'></div>
          <div class='keyLabel'>{{item.key}}</div>
          <div class='valueCView'>
            <div class='valueLabel'>{{item.value}}</div>
            <div class='unitLabel'>{{item.unit}}</div>
          </div>
        </div>
      </div>
      <div class='center'>
        <div class='centerItem' v-for="item in centerData">
          <div class='centerKey'>{{item.key}}</div>
          <div class='centerValueView'>
            <div class='centerValueLabel'>{{item.value}}</div>
            <div class='centerUnitLabel'>{{item.unit}}</div>
          </div>
        </div>
      </div>
      <div class='edge'>
        <div class='edgeItem' v-for="item in rightData">
          <div class='keyEmptyView'></div>
          <div class='keyLabel'>{{item.key}}</div>
          <div class='valueCView'>
            <div class='valueLabel'>{{item.value}}</div>
            <div class='unitLabel'>{{item.unit}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ABigScreemTop',
  props: ["leftData",'centerData','rightData'],
  data() {
    return {
    };
  },
}
</script>

<style>
.aTop {
    height: 320px;
    display: flex;
    flex-direction: row;
}

.edge {
  flex: 0.7;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: space-around;
  
}

.edgeItem {
  width: 230px;
  height: 140px;
  color: white;
  background-image: url('~@/assets/images/bigScreem/left_bg.png');
  display: flex;
  flex-direction: column;
}

.keyEmptyView {
  height: 26px;
}

.keyLabel {
  height: 16px;
  width: 100%;
  padding-left: 24px;
}

.valueCView {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: baseline;
}
                           
.valueLabel {
  padding-top: 20px;
  font-size: 34px;
  padding-right: 5px;
}


.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* justify-content: space-around; */
  align-items: center;
}

.centerItem {
  color: white;
  background-image: url('~@/assets/images/bigScreem/center_bg.png');
  width: 594px;
  height: 128px;
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.centerKey {
  font-size: 22px;
  padding-left: 109px;
}

.centerValueView {
  padding-right: 109px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.centerValueLabel {
  font-size: 44px;
  padding-right: 5px;
}




</style>
